<template>
  <div class="container-fluid">
    <div class="page-title">
      <div class="row">
        <div class="col-sm-6 col-12">
          <h2>{{ $t(title) }}</h2>
        </div>
        <div class="col-sm-6 col-12" v-if="module !== '' && page !== ''">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><router-link to="/"><i
                class="iconly-Home icli svg-color"></i></router-link></li>
            <li class="breadcrumb-item">
              <router-link :to="moduleLink" v-if="moduleLink">{{ $t(module) }}</router-link>
              <template v-else>{{ $t(module) }}</template>
            </li>
            <li class="breadcrumb-item active">{{ $t(page) }}</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { useBreadcrumbStore } from '@/store/breadcrumb'
import { storeToRefs } from 'pinia'

const { t: $t } = useI18n()
const { title, module, page, moduleLink } = storeToRefs(useBreadcrumbStore())
</script>